<template>
    <v-card v-if="!loading">
        <v-data-table 
            :items="items" 
            :items-per-page="10" 
            :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
            :headers="headers"
            :search="search"
            :custom-filter="customSearch"
            >
            <template v-slot:item="props">
                <tr>
                    <td>{{ props.item.wzvz_aanm_dt }}</td>
                    <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <span v-on="on">{{ props.item.wzvz_gebr_code_aanm }}</span>
                            </template>
                            <span>{{ props.item.wzvz_gebr_naam_aanm }}</span>
                        </v-tooltip>
                    </td>
                    <td>{{ props.item.wzvz_tabel }}: {{ props.item.wzvz_key1_waarde }}</td>
                    <td>{{ props.item.wzvz_type }}</td>
                    <td>{{ props.item.wzvz_veldnaam }}</td>
                    <td><longTextView :long_text="props.item.wzvz_veldwaarde_oud" :max_width="150" v-if="props.item.wzvz_veldwaarde_oud"/></td>
                    <td><longTextView :long_text="props.item.wzvz_veldwaarde_nieuw" :max_width="150" v-if="props.item.wzvz_veldwaarde_nieuw"/></td>
                    <td><longTextView :long_text="props.item.wzvz_opm" :max_width="150" v-if="props.item.wzvz_opm"/></td>
                    <td>{{ props.item.wzvz_status }}</td>
                    <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <span v-on="on">{{ props.item.wzvz_gebr_code_afh }}</span>
                            </template>
                            <span>{{ props.item.wzvz_gebr_naam_afh }}</span>
                        </v-tooltip>
                    </td>
                    <td>{{ props.item.wzvz_afh_dt }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    // import btn_component from "@/components/ui/buttons/btn_component.vue";
    import longTextView from "@/components/ui/fields/longTextView.vue";

    export default {
        components: {
            // btn_component,
            longTextView,
        },  
        data() {
            return {
                loading: true,
                selected: [],
                search: "",
                headers: [
                    { text: "Request date", value: "wzvz_aanm_dt", width: "7%"  },
                    { text: "Requestor", value: "wzvz_gebr_code_aanm", width: "5%" },
                    { text: "Change", value: "wzvz_tabel", width: "8%" },
                    { text: "Type", value: "wzvz_type", width: "5%" },
                    { text: "Field", value: "wzvz_veldnaam", width: "12%" },
                    { text: "Previous Value", value: "wzvz_veldwaarde_oud", width: "8%"  },
                    { text: "Requested Value", value: "wzvz_veldwaarde_nieuw", width: "8%"  },
                    { text: "Remark", value: "wzvz_opm", width: "8%"  },
                    { text: "Status", value: "wzvz_status", width: "5%" },
                    { text: "Done by", value: "wzvz_gebr_code_afh", width: "5%"  },
                    { text: "Done date", value: "wzvz_afh_dt", width: "7%"  },
                ],
                items: [],
            }
        },  
        mounted() {
            this.listWzvzCompleted(["All"]);
        },
        methods: {
            listWzvzCompleted(view) {
                this.$axios.post("ares/json/ares/wzvz/listWzvzCompleted.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "listWzvzCompleted"
                    },
                    listWzvzCompleted: {
                        list: view,
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.items = res.data.listWzvzCompleted;
                        this.loading = false;
                    }
                });
            },
            updateSearch(newValue) {
                this.search = newValue;
            },
            customSearch (value, search, item) {
                return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
            },
        }
    }
</script>

<style scoped> 
    .checkSmall {
        transform: scale(0.75);
        margin: 2px;
    }
</style>